import 'vuetify/dist/vuetify.css'
import '@/css/custom.css'
import '@/css/utilities.css'

// plugins
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import VeeValidate, { Validator } from 'vee-validate'
import it from 'vee-validate/dist/locale/it.js'
import ita from '@/locale/it.ts'
import { VueEditor } from 'vue2-editor'
import VueSignaturePad from 'vue-signature-pad'

import App from './App.vue'
import AppTabs from '@/components/AppTabs'
import Crud from '@/components/Crud'
import ConfirmDialog from '@/components/ConfirmDialog'
import InputFile from '@/components/InputFile'
import { eventBusUtility } from '@/eventBusUtility.js'
import { trans } from '@/components/utilities/trans.js'
import './library/customRules';
Vue.trans = trans


import router from '@/router'
import store from '@/store'

window._ = require('lodash')
window.moment = require('moment')
window.moment.locale('it')

Vue.use(VueAxios, axios)
Vue.use(Vuetify, {
	lang: {
		locales: { ita },
		current: 'ita'
	},
	theme: {
		primary: '#2196F3',
		secondary: '#3F51B5',
		accent: '#FFE57F',
		error: '#FF5252',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#FF6D00'
	}
})

Validator.localize('it', it)

Vue.use(VeeValidate, {
	locale: 'it'
})

Vue.component('vue-editor', VueEditor)
Vue.use(VueSignaturePad)

// register common components
Vue.component('crud', Crud)
Vue.component('app-tabs', AppTabs)
Vue.component('confirm-dialog', ConfirmDialog)
Vue.component('input-file', InputFile)

store.dispatch('SET_FQDN')

Vue.axios.defaults.headers = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
	Authorization: 'Bearer ' + localStorage.getItem('user-token')
}

Vue.axios.interceptors.response.use(response => {
	store.commit('goOnline')
	return response
},
err => {
	return new Promise((resolve, reject) => {
		if (err.message == 'Network Error') {
			store.commit('goOffline')
		}
		throw err
	})
})

router.beforeEach((to, from, next) => {
	store.commit('startProgress')
	next()
})

Vue.axios.interceptors.response.use(function(response) {
	// Do something with response data
	return response
},
error => {
	if (error.response.status == 401) {
		store.commit('setSnackbar', {
			timeout: 6000,
			text: 'Permesso negato',
			value: true,
			color: 'warning'
		})
	} else {
		store.commit('setSnackbar', {
			timeout: 6000,
			text: 'Ops.. Qualcosa è andato storto',
			value: true,
			color: 'error'
		})
	}
	return Promise.reject(error)
})

Vue.prototype.$eventBusUtility = eventBusUtility
Vue.prototype.$trans = trans

// FILTERS

Vue.filter('capitalize', function(value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('translate', function(value) {
	if (!value) return ''
	value = value.toString().toLowerCase()
	return trans(value)
})

Vue.filter('currency', function(value) {
	if (value === '') return ''
	return new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: 'EUR'
	}).format(value)
})

Vue.config.productionTip = false

new Vue({
	el: '#app',
	store,
	router,
	axios,
	render: h => h(App)
}).$mount('#app')
